<div
  class="flex items-center gap-2.5 p-0.5 rounded-full bg-secondary-50"
  [style.width]="size"
  [style.height]="size"
  [ngClass]="classes">
  <ui-icon [size]="size - 4" icon="griddy-trend-up"></ui-icon>
</div>
